import { useEffect } from 'react';

export const SITE_TITLE = 'HBAC | HUST Business Analytics Club';

/**
 * Keeps the tab title in step with client-side navigation. The Worker writes
 * the same titles into the first HTML response (api/src/seo.ts); without this
 * the tab kept the title of whichever page was loaded first.
 */
export function useDocumentTitle(title: string | null | undefined): void {
  useEffect(() => {
    if (title) document.title = title;
  }, [title]);
}
